// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { QuestionnaireConditionFragmentDoc } from '../../condition/QuestionnaireCondition.fragment.generated';
import { QuestionnaireConditionIsEmptyFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsEmpty.fragment.generated';
import { QuestionnaireConditionIsEqualToFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsEqualTo.fragment.generated';
import { QuestionnaireConditionIsGreaterThanFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsGreaterThan.fragment.generated';
import { QuestionnaireConditionIsLessThanFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsLessThan.fragment.generated';
import { QuestionnaireConditionIsNotEmptyFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsNotEmpty.fragment.generated';
import { QuestionnaireConditionNotIsEqualToFragmentDoc } from '../../condition/rules/QuestionnaireConditionNotIsEqualTo.fragment.generated';
import { QuestionnaireConditionEqualToChoiceFragmentDoc } from '../../condition/rules/QuestionnaireConditionChoiceEqualTo.generated';
export const QuestionnaireQuestionChoiceOptionContentTextConditionalFragmentDoc = `
    fragment questionnaireQuestionChoiceOptionContentTextConditional on QuestionnaireQuestionChoiceOptionContentTextConditional {
  title
  description
  conditions {
    ...questionnaireCondition
  }
}
    `;